// Ordered summary fields returned by GET /api/vin/decode (see VIN_SUMMARY_FIELDS in
// webapp/app.py). Shared by the standalone VIN Decoder card and the VIN modal on the
// onboarding status table so the two cannot drift apart.
export const VIN_SUMMARY_FIELDS = [
  { key: 'suggested_vin', label: 'Suggested VIN' },
  { key: 'vehicle_descriptor', label: 'Vehicle Descriptor' },
  { key: 'make', label: 'Make' },
  { key: 'manufacturer_name', label: 'Manufacturer' },
  { key: 'model', label: 'Model' },
  { key: 'model_year', label: 'Model Year' },
  { key: 'series', label: 'Series' },
  { key: 'trim', label: 'Trim' },
  { key: 'vehicle_type', label: 'Vehicle Type' },
  { key: 'body_class', label: 'Body Class' },
  { key: 'engine_model', label: 'Engine Model' },
  { key: 'engine_displacement_l', label: 'Displacement (L)' },
  { key: 'engine_displacement_ci', label: 'Displacement (CI)' },
  { key: 'fuel_type_primary', label: 'Fuel Type (Primary)' },
  { key: 'fuel_type_secondary', label: 'Fuel Type (Secondary)' },
  { key: 'engine_configuration', label: 'Engine Configuration' },
  { key: 'engine_manufacturer', label: 'Engine Manufacturer' },
  { key: 'fuel_injection_type', label: 'Fuel Injection' },
  { key: 'drive_type', label: 'Drive Type' },
  { key: 'gvwr', label: 'GVWR' },
  { key: 'number_of_wheels', label: 'Wheels' },
  { key: 'number_of_seats', label: 'Seats' },
  { key: 'front_air_bags', label: 'Front Air Bags' },
  { key: 'side_air_bag', label: 'Side Air Bag' },
  { key: 'brake_system_type', label: 'Brake System' },
  { key: 'plant_city', label: 'Plant City' },
  { key: 'plant_state', label: 'Plant State' },
  { key: 'plant_country', label: 'Plant Country' },
  { key: 'plant_company_name', label: 'Plant Company' }
];

export default VIN_SUMMARY_FIELDS;
